// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle u-flexSpaced\" ng-bind=\"row.entity.receiverWithLocation\">\n     </div>\n</div>";
// Exports
module.exports = code;